module.exports = function(done, value){
  return {value: value, done: !!done};
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.iter-step.js
 ** module id = 121
 ** module chunks = 1
 **/